import { STATUS_TYPE } from 'modules/campaigns/config';
import { getStatusType } from 'modules/campaigns/config/statusConsts';

export const LANDING_PAGE_STATUS = {
    DRAFT: 'DRAFT',
    PUBLISHED: 'PUBLISHED',
};

const statusConfig = {
    [LANDING_PAGE_STATUS.PUBLISHED]: { statusType: STATUS_TYPE.SUCCESS },
    [LANDING_PAGE_STATUS.DRAFT]: { statusType: STATUS_TYPE.DANGER },
};

export const getLandingPageStatusType = status => getStatusType(statusConfig, status);
